




































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { displayColorByStatusGeracaoRepasse, maskCPFCNPJ, maskDateTime, maskMoney, timeoutDefault } from '@/utils/common'
import { RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'
import FileSaver from 'file-saver'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'

@Component
export default class ComponentModalValidacaoEGeracaoRepasse extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadShowModalItensDoRepasse: string = ''
  loadShowModalDesfazerLiberacao: string = ''
  loadShowModalIntegrarRepasseUnico: string = ''
  loadShowModalRecalcularImpostos: string = ''
  loadShowModalLiberarRepasseUnico: string = ''
  loadShowModalDescontosPrestador: string = ''
  loadShowModalDesfazerIntegracao: string = ''
  loadShowModalEmitirRelatorio: boolean = false
  loadDownloadArquivos: string = ''
  loadShowModalItemAvulso: string = ''
  loadHistorico: string = ''
  loadShowModalLogs: string = ''
  loadShowModalErros: boolean | string = false
  modalLiberarRepasses: boolean = false
  selection: any[] = []
  loadingDesmembrarRepassesNegativos: boolean = false
  loadingBuscarProcedimentosFiltrados: boolean = false
  loadingCargas: boolean = false
  loadIncluirNovasProducoes: boolean = false

  get modalValidacaoEGeracaoRepasse() { return this.getFinanceiroStore.modal.validacaoEGeracaoRepasse }
  set modalValidacaoEGeracaoRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'validacaoEGeracaoRepasse', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  } 

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get headersProcedimentosDescartados() {
    return [
      { text: 'Fonte pagadora', value: 'nomeFontePagadora', align: 'center' },
      { text: 'Prestador', value: 'nomePrestador', align: 'center' },
      { text: 'Profissional', value: 'nomeProfissional', align: 'center' },
      { text: 'Função', value: 'funcao', align: 'center' },
      { text: 'Código', value: 'codigo', align: 'center' },
      { text: 'Descrição', value: 'descricao', align: 'center' },
      { text: 'Número atendimento', value: 'numeroAtendimento', align: 'center' },
      { text: 'Data realização', value: 'dataRealizacao', align: 'center' },
      { text: 'Tipo descarte', value: 'tipoDescarte', align: 'center' },
      { text: 'Observação descarte', value: 'observacaoDescarte', align: 'center' },
    ]
  }

  get procedimentosDescartados() {
    return this.getFinanceiroStore.procedimentosDescarteRecriacao
  }

  get temMensagemDeErro() {
    return this.getFinanceiroStore.podeLiberar === 'Erro'
  }

  get getPagina() {
    return this.getFinanceiroStore.paginaValidacaoEGeracao
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPaginaValidacaoEGeracao(value)
  }

  get getPaginaProcedimentos() {
    return this.getFinanceiroStore.paginaProcedimentosDescarteRecriacao
  }
  
  set getPaginaProcedimentos(value: number) {
    this.getFinanceiroStore.setPaginaProcedimentosDescarteRecriacao(value)
  }

  get loadingShowModalItensDoRepasse() {
    return this.loadShowModalItensDoRepasse
  }

  set loadingShowModalItensDoRepasse(value: string) {
    this.loadShowModalItensDoRepasse = value
  }

  get loadingShowModalDesfazerLiberacao() {
    return this.loadShowModalDesfazerLiberacao
  }

  set loadingShowModalDesfazerLiberacao(value: string) {
    this.loadShowModalDesfazerLiberacao = value
  }

  get loadingShowModalIntegrarRepasseUnico() {
    return this.loadShowModalIntegrarRepasseUnico
  }

  set loadingShowModalIntegrarRepasseUnico(value: string) {
    this.loadShowModalIntegrarRepasseUnico = value
  }

  get loadingShowModalRecalcularImpostos() {
    return this.loadShowModalRecalcularImpostos
  }

  set loadingShowModalRecalcularImpostos(value: string) {
    this.loadShowModalRecalcularImpostos = value
  }

  get loadingShowModalLiberarRepasseUnico() {
    return this.loadShowModalLiberarRepasseUnico
  }

  set loadingShowModalLiberarRepasseUnico(value: string) {
    this.loadShowModalLiberarRepasseUnico = value
  }

  get loadingShowModalDescontosPrestador() {
    return this.loadShowModalDescontosPrestador
  }

  set loadingShowModalDescontosPrestador(value: string) {
    this.loadShowModalDescontosPrestador = value
  }

  get loadingShowModalDesfazerIntegracao() {
    return this.loadShowModalDesfazerIntegracao
  }

  set loadingShowModalDesfazerIntegracao(value: string) {
    this.loadShowModalDesfazerIntegracao = value
  }

  get loadingShowModalEmitirRelatorio() {
    return this.loadShowModalEmitirRelatorio
  }

  set loadingShowModalEmitirRelatorio(value: boolean) {
    this.loadShowModalEmitirRelatorio = value
  }

  get loadingDownloadArquivos() {
    return this.loadDownloadArquivos
  }

  set loadingDownloadArquivos(value: string) {
    this.loadDownloadArquivos = value
  }

  get loadingShowModalItemAvulso() {
    return this.loadShowModalItemAvulso
  }

  set loadingShowModalItemAvulso(value: string) {
    this.loadShowModalItemAvulso = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingShowModalLogs() {
    return this.loadShowModalLogs
  }

  set loadingShowModalLogs(value: string) {
    this.loadShowModalLogs = value
  }

  get loadingShowModalErros() {
    return this.loadShowModalErros
  }

  set loadingShowModalErros(value: boolean | string) {
    this.loadShowModalErros = value
  }

  get loadingModalIncluirNovasProducoes() {
    return this.loadIncluirNovasProducoes
  }

  set loadingModalIncluirNovasProducoes(value: boolean) {
    this.loadIncluirNovasProducoes = value
  }

  get headersVisualizarGeracaoRepasse() {
    return this.getFinanceiroStore.backofficeFinanceiroGeracaoRepasseVisualizarHeaders
  }

  get headersVisualizarCargas() {
    return [
      { text: 'Criado por', value: 'createdByNome', align: 'center' },
      { text: 'Motivo inclusão', value: 'motivoInclusao', align: 'center' },
      { text: 'Tipo Carga', value: 'tipoCarga', align: 'center' },
      { text: 'Criado em', value: 'createdOn', align: 'center' },
      { text: 'Progresso', value: 'percentualConclusao', align: 'center' },
      { text: 'Nome arquivo', value: 'nomeArquivo', align: 'center' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Ação', value: 'acao', align: 'center' },
    ]
  }

  get geracaoDeRepassesItemsVisualizar() {
    return this.getFinanceiroStore.geracaoDeRepassesItemsVisualizar
  }

  get cargasVisualizarItems() {
    return this.getFinanceiroStore.cargasVisualizarItems
  }

  get acoesGeracaoRepasse() {
    return this.getFinanceiroStore.acoesGeracaoRepasse
  }

  get dadosGeraisDoRepasse() {
    return this.getFinanceiroStore.dadosGeraisDoRepasse
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getTotal() {
    return this.getFinanceiroStore.totalGeracaoDeRepasseVisualizar || 0
  }

  get desfazerIntegracao() {
    return this.getFinanceiroStore.modal.desfazerIntegracao
  }

  get repasseLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get modalDescartarRepasse() {
    return this.getFinanceiroStore.modal.descartarRepasses
  }

  get getTotalProcedimentos() {
    return this.getFinanceiroStore.totalProcedimentosDescarteRecriacao || 0
  }

  get procedimentosLength() {
    return Math.ceil(this.getTotalProcedimentos / this.getFinanceiroStore.qtdPorPagina)
  }

  get statusGeracaoDeRepasse() {
    return this.getFinanceiroStore.statusGeracaoDeRepasse
  }

  get podeAlterarDatas() {
    switch (this.statusGeracaoDeRepasse) {
      case 'Descartado':
        return false
      case 'Fechado':
        return false
      default:
        return true
    }
  }

  get calculoAtivo() { return this.getFinanceiroStore.calculoAtivo }

  get totalProcedimentosDescarteRecriacao() {
    return this.getFinanceiroStore.totalProcedimentosDescarteRecriacao
  }

  get numeroAtendimento(){
    return this.getFinanceiroStore.numeroAtendimento
  }

  set numeroAtendimento(value: string){
    this.getFinanceiroStore.setNumeroAtendimento(value)
  }

  get codigo(){
    return this.getFinanceiroStore.codigo
  }

  set codigo(value: string){
    this.getFinanceiroStore.setCodigo(value)
  }

  get dataExecucaoDe() {
    return this.getFinanceiroStore.dataExecucaoDe
  }

  set dataExecucaoDe(value: string) {
    this.getFinanceiroStore.setDataExecucaoDe(value)
  }

  get dataExecucaoAte() {
    return this.getFinanceiroStore.dataExecucaoAte
  }

  set dataExecucaoAte(value: string) {
    this.getFinanceiroStore.setDataExecucaoAte(value)
  }

  async onToggleExpand(props: any) {
    props.expanded = !props.expanded

    // Lazy-load na 1ª abertura; recarga da lista recria os itens sem descontos, então sempre reflete o dado atual.
    if (props.expanded && !props.item.descontos) {
      this.$set(props.item, 'loadingDescontos', true)
      try {
        const response = await this.getFinanceiroStore.getDescontosPrestadorRecebimento({
          geracaoRepasseId: this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse,
          prestadorRecebimentoId: props.item.id,
        })
        if (response && response.success) {
          this.$set(props.item, 'descontos', response.data.descontos || [])
          this.$set(props.item, 'valorLiquido', response.data.valorLiquido)
        }
      } finally {
        this.$set(props.item, 'loadingDescontos', false)
      }
    }
  }

  maskCpfCnpjUtil(value) {
    return maskCPFCNPJ(value)
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  formatDateTime(date) {
    return maskDateTime(date)
  }

  formatMonthUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('MM/YYYY')
  }

  formatDateUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY')
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  showModalAlterarAluguelPrestador(id: string) {
    this.getFinanceiroStore.setIdForSaveAlterarPrestador(id)
    this.getFinanceiroStore.setModal({ name: 'modalAlterarAluguelPrestador', value: true })
  }

  openModalLiberarRepasses() {
    this.getFinanceiroStore.setModal({ name: 'liberarRepasses', value: true })
  }

  openModalIntegrarRepasses() {
    this.getFinanceiroStore.setModal({ name: 'integrarRepasses', value: true })
  }

  openModalDescartarRepasses() {
    this.getFinanceiroStore.setModal({ name: 'descartarRepasses', value: true })
  }

  async openModalErrosValidacao() {
    this.loadingShowModalErros = true
    await this.getFinanceiroStore.getValidacaoErros()
    this.getFinanceiroStore.setModal({ name: 'errosValidacao', value: true })
    this.loadingShowModalErros = false
  }

   async openModalErrosCargas(item: { id: string, recebimentoId: number }) {
    this.loadingShowModalErros = item.id
    await this.getFinanceiroStore.getItemsRecebimentoErros(item.recebimentoId)
    this.getFinanceiroStore.setModal({ name: 'errosCarga', value: true })
    this.loadingShowModalErros = false
  }

  async showModalItemAvulso(id: string) {
    this.loadingShowModalItemAvulso = id
    this.getFinanceiroStore.setIdForLoadItemAvulso(id)

    // Verifica se existem itens salvos da última requisição
    const { codigoProcedimento, centroDeCusto, transacaoFinanceira, motivosInclusaoItemAvulso, funcoesProfissionalExecutante, conveniosRepasse, viasAcesso } = this.getFinanceiroStore

    if (!codigoProcedimento.length) await this.getFinanceiroStore.getProcedimentos()
    if (!transacaoFinanceira.length) await this.getFinanceiroStore.getTransacaoFinanceira()
    if (!centroDeCusto.length) await this.getFinanceiroStore.getCentroDeCusto()
    if (!funcoesProfissionalExecutante.length) await this.getFinanceiroStore.getFuncoesProfissionalExecutante()
    if (!conveniosRepasse.length) await this.getFinanceiroStore.getConveniosRepasse()
    if (!viasAcesso.length) await this.getFinanceiroStore.getViasAcesso()
    if (!motivosInclusaoItemAvulso.length) await this.getFinanceiroStore.getMotivoInclusao()

    this.getFinanceiroStore.setModal({ name: 'novoItemAvulsoRepasse', value: true, context: 'cargaDeItens' })
    this.loadShowModalItemAvulso = ''
  }

  async showHistory(item: any) {
    this.loadingHistorico = item.id
    if (item.status.key === 'Erro' && item.statusDetalhe === 'ErroIntegracao') {
      const params: any = {
        geracaoRepasseId: item.id,
        prestadorRecebimentoId: item.prestadorId,
      }
      await this.getHistoricoSituacaoStore.getHistoricoIntegracaoRepasse(params)
    } else {
      await this.getHistoricoSituacaoStore.getHistoricoGeracaoRepasse(item.id)
    }
    this.loadingHistorico = ''
  }

  async showLogs(item: any) {
    this.loadingShowModalLogs = item.id
    const geracaoId = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    this.getFinanceiroStore.setPrestadorRecebimento(item)
    await this.getFinanceiroStore.getPrestadorRecebimentoLogs({ geracaoRepasseId: geracaoId, prestadorRecebimentoId: item.id })
    this.loadingShowModalLogs = ''
  }

  showModalAlterarDatas() {
    this.getFinanceiroStore.setModal({ name: 'alterarDatas', value: true })
  }

  showModalIncluirNovasProducoes() {
    this.getFinanceiroStore.setModal({ name: 'incluirNovasProducoes', value: true })
  }

  async showModalCargaItens(id: string) {
    this.loadingShowModalItemAvulso = id
    this.getFinanceiroStore.setIdForLoadItemAvulso(id)

    // Verifica se existem itens salvos da última requisição
    const { codigoProcedimento, centroDeCusto, transacaoFinanceira, motivosInclusaoItemAvulso, funcoesProfissionalExecutante, conveniosRepasse, viasAcesso } = this.getFinanceiroStore

    if (!codigoProcedimento.length) await this.getFinanceiroStore.getProcedimentos()
    if (!transacaoFinanceira.length) await this.getFinanceiroStore.getTransacaoFinanceira()
    if (!centroDeCusto.length) await this.getFinanceiroStore.getCentroDeCusto()
    if (!funcoesProfissionalExecutante.length) await this.getFinanceiroStore.getFuncoesProfissionalExecutante()
    if (!conveniosRepasse.length) await this.getFinanceiroStore.getConveniosRepasse()
    if (!viasAcesso.length) await this.getFinanceiroStore.getViasAcesso()
    if (!motivosInclusaoItemAvulso.length) await this.getFinanceiroStore.getMotivoInclusao()

    this.getFinanceiroStore.setModal({ name: 'novoItemAvulsoRepasse', value: true, context: 'cargaGeracao' })
    this.loadShowModalItemAvulso = ''
  }

  async showModalItensDoRepasse(item: any) {
    this.loadingShowModalItensDoRepasse = item.id
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setIdForLoadPrestadores(item.fontePagadoraId)
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(item.id)
    this.getFinanceiroStore.setModal({ name: 'itensDoRepasse', value: true })

    this.getFinanceiroStore.setLoadingProfissionais(true)
    this.getFinanceiroStore.setLoadingTipoItens(true)
    this.getFinanceiroStore.setLoadingFuncoesProfissionalExecutante(true)

    await this.getFinanceiroStore.getAllProfissionais()
    await this.getFinanceiroStore.getTipoItens()
    await this.getFinanceiroStore.getFuncoesProfissionalExecutante()
    this.loadingShowModalItensDoRepasse = ''
  }

  async showModalDesfazerLiberacao(item: any) {
    this.loadingShowModalDesfazerLiberacao = item.id
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setPrestadorId(item.prestadorId)
    this.getFinanceiroStore.setModal({ name: 'desfazerLiberacao', value: true })
    this.loadingShowModalDesfazerLiberacao = ''
  }

  async openModalDesfazerIntegracao(item: any) {
    this.loadingShowModalDesfazerIntegracao = item.id
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setModal({ name: 'desfazerIntegracao', value: true })
    this.loadingShowModalDesfazerIntegracao = ''
  }

  async showModalIntegrarRepasse(item: any) {
    this.loadingShowModalIntegrarRepasseUnico = item.id
    await timeoutDefault()
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setModal({ name: 'integrarRepasseUnico', value: true })
    this.loadingShowModalIntegrarRepasseUnico = ''
  }

  async showModalRecalcularImpostosEAlugueis(item: any) {
    if (['Integrando', 'Integrado', 'Liberado'].includes(item.status.display)) {
      EventBus.$emit('setSnackbar', { show: true, text: "Somente os impostos serão recalculados.", icon: 'warning', color: 'orange' })
    }

    this.loadingShowModalRecalcularImpostos = item.id
    await timeoutDefault()
    this.getFinanceiroStore.setPrestadorIdRecalculo(item.id)
    this.getFinanceiroStore.setModal({ name: 'recalcularImpostosEAlugueis', value: true })
    this.loadingShowModalRecalcularImpostos = ''
  }

  async showModalLiberarRepasseUnico(item: any) {
    this.loadingShowModalLiberarRepasseUnico = item.id
    await timeoutDefault()
    this.getFinanceiroStore.setIdForLoadItensRepasse(item.id)
    this.getFinanceiroStore.setPrestadorRecebimentoId(item.prestadorId)
    this.getFinanceiroStore.setModal({ name: 'liberarRepasseUnico', value: true })
    this.loadingShowModalLiberarRepasseUnico = ''
  }

  async showModalDescontosPrestador(item: any) {
    this.loadingShowModalDescontosPrestador = item.id
    await timeoutDefault()
    await this.getFinanceiroStore.getAllDescontosPrestador(item.prestadorId)
    this.getFinanceiroStore.setModal({ name: 'descontosPrestador', value: true })
    this.loadingShowModalDescontosPrestador = ''
  }

  async openModalEmitirRelatorio() {
    this.loadingShowModalEmitirRelatorio = true
    this.getFinanceiroStore.setModal({ name: 'emitirRelatorio', value: true })
    this.loadingShowModalEmitirRelatorio = false
  }

  async getResults(pagina: number) {
    const id = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async getResultsProcedimentos(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPaginaProcedimentos = pagina
    await this.getFinanceiroStore.getProcedimentosDescarteRecriacao()
    EventBus.$emit('clearLoadingRequest')
  }

  async downloadArquivos(item: any) {
    this.loadingDownloadArquivos = item.id
    const response = await this.getFinanceiroStore.downloadCargasGeracao(item.id)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao baixar arquivo.', icon: 'warning', color: '#C62828' })
      this.loadingDownloadArquivos = ''
      return
    }

    fetch(response.data)
      .then((request: Response) => request.arrayBuffer())
      .then((buffer: ArrayBuffer) => new File([buffer], 'carga_recebimento.xlsx', { type: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      .then((file: File) => FileSaver.saveAs(file))

    this.loadingDownloadArquivos = ''
  }

  // Advanced-filters
  get drawer() {
    return this.getFinanceiroStore.filterValidacaoEGeracaoRepasseDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterValidacaoEGeracaoRepasseDrawer(value)
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async clearAdvancedFilters() {
    this.getFinanceiroStore.clearFilterValidacaoEGeracaoRepasse()
    
    if(this.getFinanceiroStore.profissionais){
      this.getFinanceiroStore.setProfissionais('')
    }

    this.getFinanceiroStore.setFilterOn(false)
    const id = this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse
    await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(id)
  }

  async desmembrarRepassesNegativos(){
    this.loadingDesmembrarRepassesNegativos = true
    const response = await this.getFinanceiroStore.desmembrarRepassesNegativos()

    if(!response.success){
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao desmembrar repasses negativos.', icon: 'warning', color: '#C62828' })
      this.loadingDesmembrarRepassesNegativos = false
      return
    }

    this.loadingDesmembrarRepassesNegativos = false
    EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Repasses negativos desmembrados com sucesso.', icon: 'done', color: '#2E7D32' })
    await this.getResults(1)
  }

  async buscarProcedimentosFiltrados() {
    this.loadingBuscarProcedimentosFiltrados = true
    await this.getFinanceiroStore.getProcedimentosDescarteRecriacao()
    this.loadingBuscarProcedimentosFiltrados = false
  }

  async clearFilter(filter: string) {
    this[filter] = ''
    await this.buscarProcedimentosFiltrados()
  }

  async atualizarCargas(){
    this.loadingCargas = true
    await this.getFinanceiroStore.getCargasVisualizarItems();
    this.loadingCargas = false
  }

  @Watch('modalValidacaoEGeracaoRepasse')
  onChangeModalValidacaoEGeracaoRepasse(value: boolean) {
    if (!value) {
      this.clearAdvancedFilters()
      this.getFinanceiroStore.clearProcedimentos()
      this.getFinanceiroStore.clearTransacaoFinanceira()
      this.getFinanceiroStore.clearCentroDeCusto()
      this.getFinanceiroStore.clearProfissionaisExecutantes()
      this.getFinanceiroStore.clearMotivosInclusao()
      this.getFinanceiroStore.clearPagePagination()
      this.getFinanceiroStore.clearItensDeRepasseSelecionados()
    }
  }

  @Watch('desfazerIntegracao')
  onChangeResponseSuccessDesfazerIntegracao(value: boolean) {
    if (!value) {
      this.getResults(1)
    }
  }

  get selected() { return this.getFinanceiroStore.itensDeRepasseSelecionados }
  set selected(value: any) { this.getFinanceiroStore.setItensDeRepasseSelecionados(value) }

  get algumItemAptoAIntegrar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.some((item: any) => Boolean(item.acoes.PodeIntegrar)) }
  get algumItemAptoALiberar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.some((item: any) => Boolean(item.acoes.PodeLiberar)) }

  openModalIntegrarItensDeGeracaoDeRepasseNoHis() {
    this.getFinanceiroStore.setModal({ name: 'integrarRepasseMultiplo', value: true })
  }

  openModalLiberarItensDeGeracaoDeRepasseNoHis() {
    this.getFinanceiroStore.setModal({ name: 'liberarRepasseMultiplo', value: true })
  }

  displayColor(item: { status: { key: string, display: string } }) {
    return displayColorByStatusGeracaoRepasse(item.status.display)
  }
}
